import styled from '@emotion/styled';
import { FC } from 'react';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import spinner from '../../../assets/spinner.gif';

interface Props {
  visible?: boolean;
  className?: string;
}

const SigningInIndicatorScreen: FC<Props> = ({ visible = false, className }) => {
  const Indicator = styled('div')({
    width: 64,
    height: 64,
    backgroundImage: spinner,
    backgroundSize: 'cover',
  });
  return (
    <Root
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        visibility: visible ? 'visible' : 'hidden',
        transition: `opacity 300ms ease-in-out 0ms,
                visibility 0ms linear ${visible ? 0 : 300}ms`,
      }}
    >
      <Indicator
        style={{
          opacity: visible ? 1 : 0,
        }}
      />
    </Root>
  );
};

const Root = styled('div')(
  flexibleLayoutContainer({
    alignItems: 'center',
    justifyContent: 'center',
  }),
  {
    background: '#fff',
  },
);

export default SigningInIndicatorScreen;
